import { render, staticRenderFns } from "./SystemSms.vue?vue&type=template&id=20d1ce8f&"
import script from "./SystemSms.vue?vue&type=script&lang=js&"
export * from "./SystemSms.vue?vue&type=script&lang=js&"
import style0 from "./SystemSms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports